<template>
    <div>
        <div class="position-relative">
          <!-- shape Hero -->
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-workshop">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white">{{ workshop.title }}</h1>
                              <p class="lead  text-white">{{ $t('workshops.' + $route.params.id + '.description') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        </div>
        <section class="section section-lg mt--100">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">{{ workshop.title }}</h2>
                        <p v-if="workshop.text1" class="lead">{{ $t('workshops.' + $route.params.id + '.text1') }}</p>
                        <p v-if="workshop.text2">{{ $t('workshops.' + $route.params.id + '.text2') }}</p>
                        <p v-if="workshop.text3">{{ $t('workshops.' + $route.params.id + '.text3') }}</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">{{ $t('workshop.title1') }}</h4>
                            <p class="mt-0">{{ $t('workshop.para1') }}</p>                            
                            <form accept-charset="UTF-8" action="https://usebasin.com/f/87407d9533ff" method="POST" ref="form">
                              <base-input
                                class="mt-5"
                                alternative
                                :placeholder="$t('workshop.form.firstName')"
                                addon-left-icon="ni ni-user-run"
                                v-model="form.firstName"
                              >
                              </base-input>
                              <base-input
                                alternative
                                :placeholder="$t('workshop.form.lastName')"
                                addon-left-icon="ni ni-badge"
                                v-model="form.lastName"
                              >
                              </base-input>
                              <base-input
                                alternative
                                :placeholder="$t('workshop.form.companyName')"
                                addon-left-icon="ni ni-shop"
                                v-model="form.companyName"
                              >
                              </base-input>
                              <base-input
                                v-model="form.email"
                                :placeholder="$t('workshop.form.email')"
                                addon-left-icon="ni ni-email-83"
                                alternative
                                required
                                type="email"
                              >
                              </base-input>
                              <base-input
                                alternative
                                :placeholder="$t('workshop.form.phoneNumber')"
                                addon-left-icon="ni ni-tag"
                                v-model="form.phoneNumber"
                                required
                              >
                              </base-input>
                              <base-input class="mb-4">
                                <textarea
                                  v-model="form.text"
                                  :placeholder="$t('contact.form.body')"
                                  class="form-control form-control-alternative"
                                  name="name"
                                  rows="4"
                                  cols="80"
                                  required
                                >
                                </textarea>
                              </base-input>
                              <base-checkbox class="mb-4" v-model="form.checked">
                                {{ $t('workshop.form.checked', { name: this.workshop.title }) }}
                              </base-checkbox>
                              <base-button v-on:click="submit" type="default" round block size="lg">
                                {{ $t('workshop.form.submit') }}
                              </base-button>
                            </form>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import workshopsData from '../data/workshops.js';

export default {
  name: "workshop",
  components: {},
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        phonenumber: '',
        checked: true,
        workshopID: this.$route.params.id,
        local: this.$root.$i18n.locale,
        body: '' // Body is required
      }
    }
  },
  computed: {
    workshop() {
      let grouped = [];
      let index = -1;
      for (let i = 0; i < workshopsData.length; i++) {
        if (workshopsData[i].slug === this.$route.params.id) {
          return workshopsData[i]
        }
      }
    }
  },
  methods: {
    submit: function() {
      this.$refs.form.submit();
    }
  }
};
</script>